import React, { FC, ReactElement, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
// Components
import InputField from '../../../components/form/input';
import EditReservationWrapper from './editReservationWrapper';
// Hooks
import { useUpdateRide } from '../../../core/services/rides';
// Resources
import { stringsRes } from '../../../resources/strings';
import { EditRideInput, Ride } from '../../../core/apiTypes';
import { PropsFromModal } from '../../../components/modals/createModalHOC';
import { isWebView } from '../../../utils/webview';

interface EditReservationDriverMessageProps extends PropsFromModal {
    reservation: Ride;
}

const EditReservationDriverMessage: FC = (props: EditReservationDriverMessageProps): ReactElement => {
    const { reservation, onRequestClose } = props;

    const classes = useStyles();

    const [message, setMessage] = useState<string>('');

    const updateRide = useUpdateRide();
    // Old way
    // const { id } = useParams();
    // const { data: reservation } = useGetReservation<Ride>({
    //     enabled: !!id,
    //     variables: { id },
    // });

    useEffect(() => {
        if (reservation?.driver_note) {
            setMessage(reservation.driver_note);
        }
    }, [reservation]);

    const onMessageChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setMessage(event.target.value);
    };

    const onConfirm = (): void => {
        const payload: EditRideInput = {
            id: reservation.id,
            driver_note: message,
        };

        updateRide.mutate(payload, {
            onSuccess: () => {
                onRequestClose();
            },
        });
    };

    const isWebview = isWebView();

    return (
        <EditReservationWrapper {...props} onConfirm={onConfirm} loadingConfirm={updateRide.isLoading}>
            <InputField
                name="message"
                label={stringsRes.booking.msgHeader}
                value={message}
                autoFocus={!isWebview}
                onChange={onMessageChange}
                minRows={5}
                maxRows={10}
                InputProps={{ disableUnderline: true }}
                multiline
                className={classes.textArea}
                onFocus={(e: any) => {
                    const tmp = e.target.value;
                    e.target.value = '';
                    e.target.value = tmp;
                }}
            />
        </EditReservationWrapper>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        textArea: {
            flex: 1,
            width: '100%',
        },
    }),
);

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    // prefillRide: currentBookingActions.prefillRide,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditReservationDriverMessage);
